// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__g9aEM","isActive":"SearchBar_isActive__AHENu","input":"SearchBar_input__i3pFr","closeButton":"SearchBar_closeButton__DSAVr"};